export default {
    name: 'geoservice',
    dependencies: ['xhrservice'],
    callable(xhr) {
        function getCurrentPosition(opts) {
            return new Promise((resolve, reject) => {
                if (navigator.geolocation) {
                    // timer is a workaround for when the geo api doesnt work. This has been
                    // observed to happen in chrome, where it triggered neither success or
                    // error callback, thus hanging forever.
                    const timerId = setTimeout(reject, 60000);
                    navigator.geolocation.getCurrentPosition(
                        pos => {
                            clearTimeout(timerId);
                            const coords = {
                                latitude: round(pos.coords.latitude),
                                longitude: round(pos.coords.longitude),
                            };
                            resolve(coords);
                        },
                        e => {
                            clearTimeout(timerId);
                            reject(
                                new Error(
                                    `Could not find position with error: ${e}`
                                )
                            );
                        },
                        opts
                    );
                } else {
                    reject(new Error('Could not find position'));
                }
            });
        }

        function round(value) {
            // 5 digits is precise down to ~1.11 meters: https://en.wikipedia.org/wiki/Decimal_degrees
            return Math.round(value * 100000) / 100000;
        }

        function getLocationName(mapApiUrl, lat, lon) {
            return xhr
                .getJson(`${mapApiUrl}/geo/locations/${lat},${lon}.json`)
                .then(
                    response =>
                        findClosestLocationName(
                            response.areaInfo.locationsNearby
                        ) || null
                )
                .catch(() => null);
        }

        function findClosestLocationName(locations) {
            const closestPostalNumberLocation = locations.filter(
                location => location.areaType === 2
            )[0];
            if (closestPostalNumberLocation.name === 'Oslo') {
                const district = locations.filter(
                    location => location.areaType === 6
                )[0];
                return (
                    (district ? `${district.name}, ` : '') +
                    closestPostalNumberLocation.name
                );
            }
            return closestPostalNumberLocation
                ? closestPostalNumberLocation.name
                : locations[0].name;
        }

        function getLastLocations(vertical) {
            return xhr.getJson(`/user/${vertical}/locations.json`);
        }

        function saveLocation(lat, lon, locationName, radius, vertical) {
            xhr.request({
                url: '/user/save/location.json',
                method: 'POST',
                data: { lat, lon, name: locationName, radius, vertical },
            });
        }

        return {
            getCurrentPosition,
            getLocationName,
            round,
            saveLocation,
            getLastLocations,
        };
    },
};



// WEBPACK FOOTER //
// ./services/geoservice.js